import { WebpLazyImage } from '@src/components/WebpLazyImage/WepbLazyImage'
import Star1 from './svg/star1.svg'
import Star2 from './svg/star2.svg'
import Star3 from './svg/star3.svg'
import Star4 from './svg/star4.svg'
import Star5 from './svg/star5.svg'

interface StarRatingProps {
  rating?: number
  disabled?: boolean
  size?: string
}

const StarRating: React.FC<StarRatingProps> = ({ rating, disabled = false, size = 'sm' }) => {
  const stars = [Star1, Star2, Star3, Star4, Star5]

  if (!rating) return null

  return (
    <div className={`flex ${disabled ? 'filter grayscale' : ''}`} aria-label={`${rating} star rating`}>
      {stars.slice(0, rating).map((StarIcon, index) => (
        <WebpLazyImage
          key={index}
          src={StarIcon}
          alt={`Star ${index + 1}`}
          width={size === 'lg' ? '30' : '15'}
          height={size === 'lg' ? '30' : '15'}
        />
      ))}
    </div>
  )
}

export default StarRating
